import 'svelte/internal/disclose-version';
import * as $ from 'svelte/internal/client';
import TopBar from '../components/layout/TopBar.svelte';
import EmptyState from '../components/shared/EmptyState.svelte';
import ReminderCard from '../components/reminders/ReminderCard.svelte';
import ReminderForm from '../components/reminders/ReminderForm.svelte';
import NextUp from '../components/reminders/NextUp.svelte';
import { getAllRemindersForChild } from '../lib/services/reminders';
import { getActiveChild } from '../lib/stores/children.svelte.ts';

var root_2 = $.from_html(`<div class="reminder-list svelte-18umhgf860rig"></div>`);
var root = $.from_html(`<!> <div class="reminders-page svelte-18umhgf860rig"><!> <!></div> <button class="fab svelte-18umhgf860rig" aria-label="Add reminder"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" class="svelte-18umhgf860rig"><path d="M12 5v14M5 12h14"></path></svg></button> <!>`, 1);

function Reminders($$anchor, $$props) {
	$.push($$props, true);

	const activeChild = $.derived(getActiveChild);
	let reminders = $.state($.proxy([]));
	let showForm = $.state(false);

	$.user_effect(() => {
		if (!$.get(activeChild)) return;

		loadData();
	});

	async function loadData() {
		if (!$.get(activeChild)) return;

		$.set(reminders, await getAllRemindersForChild($.get(activeChild).id), true);
	}

	var fragment = root();
	var node = $.first_child(fragment);

	TopBar(node, { title: 'Reminders', showBack: true, backPath: '/more' });

	var div = $.sibling(node, 2);
	var node_1 = $.child(div);

	NextUp(node_1, {});

	var node_2 = $.sibling(node_1, 2);

	{
		var consequent = ($$anchor) => {
			var fragment_1 = $.comment();
			var node_3 = $.first_child(fragment_1);

			EmptyState(node_3, {
				title: 'No reminders',
				description: 'Set gentle reminders for pumping, feeding, or self-care',
				icon: '🔔'
			});

			$.append($$anchor, fragment_1);
		};

		var alternate = ($$anchor) => {
			var div_1 = root_2();

			$.each(div_1, 21, () => $.get(reminders), (reminder) => reminder.id, ($$anchor, reminder) => {
				var fragment_2 = $.comment();
				var node_4 = $.first_child(fragment_2);

				ReminderCard(node_4, {
					get reminder() {
						return $.get(reminder);
					},
					onchange: loadData
				});

				$.append($$anchor, fragment_2);
			});

			$.reset(div_1);
			$.append($$anchor, div_1);
		};

		$.if(node_2, ($$render) => {
			if ($.get(reminders).length === 0) $$render(consequent); else $$render(alternate, -1);
		});
	}

	$.reset(div);

	var button = $.sibling(div, 2);
	var node_5 = $.sibling(button, 2);

	ReminderForm(node_5, {
		get open() {
			return $.get(showForm);
		},
		onclose: () => $.set(showForm, false),
		onsaved: loadData
	});

	$.delegated('click', button, () => $.set(showForm, true));
	$.append($$anchor, fragment);
	$.pop();
}

if (import.meta.hot) {
	Reminders = $.hmr(Reminders);

	import.meta.hot.accept((module) => {
		$.cleanup_styles('svelte-18umhgf860rig');
		Reminders[$.HMR].update(module.default);
	});
}

export default Reminders;

$.delegate(['click']);
import "bun-svelte:Reminders.svelte-3p1i4z2saq7d9-style.css";